import ChartDataParser from "./ChartDataParser";

export default class ChartDataProvider {
    static getUrl(provider, granularity, channels, group, index = null, sort = null) {
        let url = provider;

        url += "&granularity=" + granularity;
        url += "&channels=" + this.getChannels(channels);
        url += "&group=" + group;
        url += "&sort=" + sort;

        if (index) {
            url += "&index=" + index;
        }

        return url;
    }

    /**
     * Sanitize channels from output binding
     * @param channels
     * @returns {Array}
     */
    static getChannels(channels) {
        let ret = [];
        let arr = channels.split(",");
        for (let channel of arr) {
            if (channel.indexOf("=")) {
                let parts = channel.split("=");
                ret.push(parts[0]);
            } else {
                ret.push(channel);
            }
        }
        return ret;
    }

    static load(provider,granularity, channels, group, index = null, sort = null, indexLabels = null) {
        return new Promise((resolve, reject) => {
            let url = this.getUrl(provider, granularity, channels, group, index, sort);
            $.ajax({
                url: url,
                context: this,
                cache: false,
                data: [],
                method: "POST"
            }).fail((data) => {
                reject(data);
            }).done((response) => {
                try {
                    let data;

                    /*always process indexed labels*/
                    indexLabels = ((indexLabels && (indexLabels.trim() !== "")) ? JSON.parse(indexLabels) : {});

                    if (index) {
                        data = ChartDataParser.parseIndexed(JSON.parse(response), channels, indexLabels);
                    } else {
                        data = ChartDataParser.parse(JSON.parse(response), channels, "", false, null, false, indexLabels);
                    }

                    data["url"] = url;

                    resolve(data);
                } catch(e) {
                    console.log(e);
                    reject(null);
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/chart/data/ChartDataProvider.js